import gsap from 'gsap'

import {
  fadeRevealAnimation,
  getScrollTriggerOptions,
  linesRevealAnimation,
  paragraphRevealAnimation,
  type SharedAnimation
} from './shared'
import { Animation } from '@/types'

export const introTextRevealAnimation = ({
  node,
  context,
  reverse,
  delay = 0
}: Animation) => {
  const selector = context?.selector || gsap.utils.selector(node)

  const title = selector('[data-motion-title]')[0]
  const subtitle = selector('[data-motion-subtitle]')[0]
  const paragraph = selector('[data-motion-paragraph]')[0]

  const timeline = gsap.timeline({
    ...getScrollTriggerOptions(node, reverse),
    delay
  })

  let titleAnimation: SharedAnimation
  if (title) {
    titleAnimation = linesRevealAnimation(title, reverse)
    timeline.add(titleAnimation.timeline, 0)
  }

  let subtitleAnimation: SharedAnimation
  if (subtitle) {
    subtitleAnimation = paragraphRevealAnimation(subtitle, reverse)
    timeline.add(subtitleAnimation.timeline, 0.1)
  }

  let paragraphAnimation: SharedAnimation
  if (paragraph) {
    paragraphAnimation = fadeRevealAnimation(paragraph)
    timeline.add(paragraphAnimation.timeline, 0.3)
  }

  return () => {
    timeline.kill()

    titleAnimation?.revert()
    subtitleAnimation?.revert()
    paragraphAnimation?.revert()
  }
}
